export default __webpack_public_path__ + "assets/link.4a233311.svg";